(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
	(function () {
		const AUTOPLAY_MS = 5000;
		const timers = new WeakMap();

		function getDots(carousel) {
			return Array.prototype.slice.call(carousel.querySelectorAll('[data-testimonial-dot]'));
		}

		function goTo(carousel, index) {
			const track = carousel.querySelector('[data-testimonials-track]');
			const dots = getDots(carousel);
			const count = dots.length;
			if (!count) {
				return;
			}

			const next = ((index % count) + count) % count;

			if (track) {
				track.style.transform = `translateX(-${next * 100}%)`;
			}

			dots.forEach((item) => {
				const isActive = Number(item.dataset.testimonialDot) === next;
				item.classList.toggle('is-active', isActive);
				item.setAttribute('aria-selected', isActive ? 'true' : 'false');
			});
		}

		function currentIndex(carousel) {
			const dots = getDots(carousel);
			for (let i = 0; i < dots.length; i++) {
				if (dots[i].classList.contains('is-active')) {
					return Number(dots[i].dataset.testimonialDot);
				}
			}
			return 0;
		}

		function stopAutoplay(carousel) {
			const timer = timers.get(carousel);
			if (timer) {
				window.clearInterval(timer);
				timers.delete(carousel);
			}
		}

		function startAutoplay(carousel) {
			stopAutoplay(carousel);

			if (getDots(carousel).length < 2) {
				return;
			}

			const timer = window.setInterval(() => {
				if (!document.body.contains(carousel)) {
					stopAutoplay(carousel);
					return;
				}

				goTo(carousel, currentIndex(carousel) + 1);
			}, AUTOPLAY_MS);

			timers.set(carousel, timer);
		}

		document.addEventListener('click', (event) => {
			const dot = event.target.closest('[data-testimonial-dot]');
			if (!dot) {
				return;
			}

			const carousel = dot.closest('.cart-drawer__testimonials');
			if (!carousel) {
				return;
			}

			goTo(carousel, Number(dot.dataset.testimonialDot));
			startAutoplay(carousel);
		});

		function initAll() {
			const carousels = document.querySelectorAll('.cart-drawer__testimonials');
			Array.prototype.forEach.call(carousels, (carousel) => {
				if (carousel.dataset.carouselReady === 'true') {
					return;
				}

				carousel.dataset.carouselReady = 'true';
				startAutoplay(carousel);
			});
		}

		initAll();
		window.setInterval(initAll, 1000);
	})();

	(function () {
		const ADD_ACTIONS = ['addItem', 'addItems'];

		function init() {
			if (!window.themeCore || !window.themeCore.EventBus) {
				window.setTimeout(init, 50);
				return;
			}

			const bus = window.themeCore.EventBus;

			bus.listen('cart:updated', (data) => {
				if (data && ADD_ACTIONS.indexOf(data.action) !== -1) {
					document.body.classList.add('cart-just-added');
				}
			});

			bus.listen('cart:drawer:close', () => {
				document.body.classList.remove('cart-just-added');
			});
		}

		init();
	})();

  } catch(e) { console.error(e); }
})();
})();
